import ReportBase from 'app/models/report_base';

export default ReportBase.extend({
  reportType: 'cash_flow',
});



// WEBPACK FOOTER //
// ./app/models/cash_flow_report.js